import * as faceapi from 'face-api.js'
import { useCallback, useEffect } from 'react'
import { useState } from 'react'

function isFaceDetectionModelLoaded() {
  return !!faceapi.nets.tinyFaceDetector.params
}

const loadModel = async () => {
  console.log('faceDetection: loading model...')
  try {
    await faceapi.nets.tinyFaceDetector.load('/models')
    console.log('faceDetection: model loaded...')
  } catch (err) {
    console.error(err)
    alert('顔認識モデルを読み込めませんでした。')
  }
}

const detect = async (input: HTMLVideoElement, lastX: number) => {
  if (input.videoWidth === 0) return lastX
  let detection: faceapi.FaceDetection | undefined
  const detectorOptions = new faceapi.TinyFaceDetectorOptions()
  try {
    detection = await faceapi.detectSingleFace(input, detectorOptions)
  } catch (err) {
    console.error(err)
  }
  if (!detection) return lastX
  const vw = input.videoWidth
  const bw = detection.box.width
  const l = detection.box.left
  const r = detection.box.right
  const x = Math.round(
    Math.min(100, Math.max(-100, (90 * (vw - l - r)) / (vw - bw)))
  )
  return x
}

export const useFaceDetection = (
  videoRef: React.RefObject<HTMLVideoElement>
) => {
  const [x, setX] = useState(0)
  const [modelLoaded, setModelLoaded] = useState(false)

  //   カスタムフックスを初期化するタイミングでモデルを初期化する
  useEffect(() => {
    if (isFaceDetectionModelLoaded()) return
    loadModel().then(() => {
      if (isFaceDetectionModelLoaded()) setModelLoaded(true)
    })
  }, [])

  const startDetection = useCallback(async () => {
    if (videoRef.current) {
      try {
        setX(await detect(videoRef.current, x))
      } catch (err) {
        console.error(err)
        alert('顔認識に失敗しました。')
      }
      setTimeout(() => startDetection(), 200)
    }
  }, [videoRef, x])

  return { modelLoaded, startDetection, x }
}
